var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M27.9068 15.3991C27.9068 23.9455 18.1508 28.8451 13.9535 32V23.2113L15.1378 22.1816L15.1701 22.1534C19.3584 18.4909 22.1213 16.0749 22.1213 13.1116C22.1213 10.6908 20.1447 8.78873 17.629 8.78873C16.2078 8.78873 14.8438 9.42537 13.9535 10.4314V0L27.9068 6.15962V15.3991Z",
    fill: "#5C4BAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.15962L13.9533 0V10.4314C13.063 9.42537 11.699 8.78873 10.2778 8.78873C7.7621 8.78873 5.7855 10.6908 5.7855 13.1116C5.7855 16.0801 8.55799 18.4993 12.7586 22.1648L12.7689 22.1738L13.9533 23.2113V32C9.98283 29.2958 0 23.9455 0 15.3991V6.15962Z",
    fill: "#5C4BAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1e8e84f76bacfc307e2503f303932381.svg";
export { ForwardRef as ReactComponent };